import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.5039 2.13622C16.1925 1.95459 15.8075 1.95459 15.4961 2.13622L3.49613 9.13622C3.18891 9.31543 3 9.64433 3 10C3 10.3557 3.18891 10.6846 3.49613 10.8638L15.4961 17.8638C15.8075 18.0454 16.1925 18.0454 16.5039 17.8638L28.5039 10.8638C28.8111 10.6846 29 10.3557 29 10C29 9.64433 28.8111 9.31543 28.5039 9.13622L16.5039 2.13622ZM16 15.8423L5.98464 10L16 4.1577L26.0154 10L16 15.8423Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.13614 15.4961C3.41442 15.0191 4.02674 14.8579 4.50379 15.1362L15.9999 21.8423L27.496 15.1362C27.9731 14.8579 28.5854 15.0191 28.8637 15.4961C29.142 15.9732 28.9808 16.5855 28.5038 16.8638L16.5038 23.8638C16.1924 24.0454 15.8074 24.0454 15.496 23.8638L3.49605 16.8638C3.019 16.5855 2.85786 15.9732 3.13614 15.4961Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.13614 21.4961C3.41442 21.0191 4.02674 20.8579 4.50379 21.1362L15.9999 27.8423L27.496 21.1362C27.9731 20.8579 28.5854 21.0191 28.8637 21.4961C29.142 21.9732 28.9808 22.5855 28.5038 22.8638L16.5038 29.8638C16.1924 30.0454 15.8074 30.0454 15.496 29.8638L3.49605 22.8638C3.019 22.5855 2.85786 21.9732 3.13614 21.4961Z",
			fill: "currentColor"
		})
	]
});
export default SvgLayers;
